<template>
  <div :id='"tl-event-" + event.id'
        :style='style'
        class='text-white absolute flex flex-col shadow-lg rounded'
        :class='topClass'>
    <div v-if='isSelected' class='flex flex-row justify-between grow pbc-z-level-1 relative'>
      <hammer-pannable v-if='isSelected && isActive && !disableSides' 
                      class="-ml-8 timeline-event-handle left pbc-z-level-1 absolute left-0 outline-button"
                      :style='{"background-color":color}'
                      @panend='$emit("updated", {event})'
                      v-model='start'>
          <arrow-left-bold :size='12' />
      </hammer-pannable>
      <hammer-pannable v-if='isSelected && isActive'
                      :class="middleClass"
                       class='overflow-hidden'
                      :enable-tap='true'
                      @panend='$emit("updated", {event})'
                      @tap='$emit("select", event)'
                      v-model='middle'>
        <span v-if='showLabel' class="text-xs whitespace-pre truncate table-cell align-middle my-auto text-gray-200">{{event.label}}</span>
      </hammer-pannable>
      <hammer-pannable v-if='isSelected && isActive && !disableSides'
                      class="-mr-8 timeline-event-handle right pbc-z-level-1 absolute right-0 outline-button"
                      :style='{"background-color":color}'
                      @panend='$emit("updated", {event})'
                      v-model='end'>
        <arrow-right-bold :size='12' />
      </hammer-pannable>

      <div class="absolute text-gray-500 -ml-16 bottom-0 left-0 pointer-events-none">{{(event.start).toFixed(1)}}s</div>
      <div class="absolute text-gray-500 -mr-16 bottom-0 right-0 pointer-events-none">{{(event.start + event.duration).toFixed(1)}}s</div>


    </div>

    <div v-else-if='isActive' class="h-full text-xs font-thin">
      <button class="w-full h-full" @click='$emit("select", event)'>
        <span v-if='showLabel' class="mx-auto my-auto overflow-hidden text-xs text-gray-400">{{event.label}}</span>
      </button>
      <!--
      <div class="absolute text-gray-500 -ml-8 top-0 left-0">{{(event.start).toFixed(1)}}s</div>
      <div class="absolute text-gray-500 -mr-8 top-0 right-0">{{(event.start + event.duration).toFixed(1)}}s</div>
      -->
    </div>

  </div>
</template>
<script>
import HammerPannable from '@ui/atoms/HammerPannable.vue';
import ArrowLeftBold from '@icons/ArrowLeftBold.vue';
import ArrowRightBold from '@icons/ArrowRightBold.vue';
export default {
  props: {
    event: {
      type: Object,
      required: true
    },
    timeline: {
      type: Object,
      required: true
    },
    heightClass: {
      type: String,
      default: 'h-4'
    },
    timelineElementWidth: {
      type: Number,
      required: true
    },
    windowDuration: {
      type: Number,
      required: true
    },
    disableSides: {
      type: Boolean,
      default: false
    },
    windowCenter: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: '0xff00ff'
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isSelected:{
      type: Boolean,
      default: false
    },
    currentTime: {
      type: Number,
      default: 0
    },
    showLabel:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isPressed: false,
      minDuration: 0.3
    }
  },
  components:{
    ArrowLeftBold,
    ArrowRightBold,
    HammerPannable,
  },
  mounted() {
  },
  methods: {
    addTimelineEntry() {
      this.$emit("add-timeline-event", {
        event:this.event
      });
    },
    onPress() {
    },
    onPressUp() {
    },
    onPanCenter({deltaX,deltaY}) {
    },
    middleBoundsChecker(nv) {
      const t = this.convertPixelsToTime(nv);
      const valid = t >= 0 && t <= this.timeline.duration - this.event.duration;
      if (valid) {
        return {
          valid
        }
      } else {
        if (t <= 0) {
          return {valid,v:0}
        } else {
          return {valid,v:this.convertTimeToPixels(this.timeline.duration - this.event.duration)}
        }
      }
    },
    convertPixelsToTime(nv) {
      return nv / this.timelineElementWidth * this.windowDuration;
    },
    convertTimeToPixels(nv) {
      return (nv * this.timelineElementWidth) / this.windowDuration;
    }
  },
  computed:{
    /*
    isFiring() {
      return this.currentTime >= this.event.start  && (this.currentTime < this.event.start + this.event.duration);
    },
    */
    topClass() {
      const classes = [this.heightClass];
      if (this.isActive || this.isSelected) {
      }

      if (this.isSelected) {
        classes.push('border-2');
        classes.push('border-solid');
        classes.push('border-blue-400');
      } else {
        //classes.push('opacity-50');
      }
      
      classes.push('border-box');

      return classes;
    },
    middleClass() {
      const classes = ["grow",
        "text-white",
        "text-center",
        "text-xs",
        "font-thin",
        "truncate",
        "overflow-hidden",
        'user-select-none'
      ]
      classes.push(this.heightClass);
      return classes;
    },
    style() {
      const {start,duration,label,id} = this.event;

      const centerOffset = ((this.windowCenter - this.windowDuration/2)/ this.windowDuration)*100;

      const begin = (start / this.windowDuration * 100 - centerOffset).toFixed(2) + '%';
      const end = ((start + duration) / this.windowDuration * 100 - centerOffset).toFixed(2) + '%';
      const width = (duration / this.windowDuration * 100) .toFixed(2) + '%';

      return {
        'left':begin,
        'top':'0px',
        'width':width,
        'background-color':this.color
      }
    },
    start: {
      set(nv) {
        const currentEnd = this.event.start + this.event.duration;
        const newStart = nv / this.timelineElementWidth * this.windowDuration;
        this.event.duration = Math.max(this.minDuration,currentEnd - newStart);
        this.event.start = Math.min(newStart, currentEnd - this.event.duration);
        //this.event.start = Math.max(0, Math.min(newStart, this.timeline.duration - this.event.duration));;
      },
      get() {
        return this.event.start / this.windowDuration * this.timelineElementWidth;
      }
    },
    end: {
      set(nv) {
        this.event.duration = nv / this.timelineElementWidth * this.windowDuration - this.event.start;
        this.event.duration = Math.max(this.minDuration, Math.min(this.event.duration, this.timeline.duration - this.event.start));

        //if (this.event.duration < this.minDuration) {
          //this.event.start = Math.max(0,this.event.start - this.minDuration - this.event.duration);
        //}
      },
      get() {
        return (this.event.start + this.event.duration) / this.windowDuration * this.timelineElementWidth;
      }
    },
    middle:{
      set(nv) {
        this.event.start = nv / this.timelineElementWidth * this.windowDuration;
        this.event.start = Math.max(0, Math.min(this.event.start, this.timeline.duration - this.event.duration));
      },
      get() {
        return this.event.start / this.windowDuration * this.timelineElementWidth;
      }
    },
  }
}
</script>
<style>
.timeline-event-handle {
  @apply flex flex-col justify-center text-white h-full w-8;
  @apply shadow-inner;
  margin-top:-0.1rem;
}

.timeline-event-handle.left {
  @apply border-l-2;
  @apply border-t-2;
  @apply border-b-2;
  @apply border-blue-400;
  box-sizing: border-box;
}
.timeline-event-handle.right {
  @apply border-r-2;
  @apply border-t-2;
  @apply border-b-2;
  @apply border-blue-400;
  box-sizing: border-box;
}

</style>
